import { Component, OnInit } from '@angular/core';
import { FunctionsService } from "../../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../../api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
    selector: 'app-view-receipt',
    templateUrl: './view-receipt.component.html',
    styleUrls: ['./view-receipt.component.css'],
    providers: [NgxSpinnerService]
})

export class ViewReceiptComponent implements OnInit {
  
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    formSubmitted: boolean = false;
    loading = false;
    submitted = false;
    formProcess = false;
    message = "";
    organization:any;
    paymentId:any;
    paymentInfo:any;
    subscription:any;
    pdfInBase64:any;
    button = document.querySelector('button');

    constructor(
        private activatedRoute:ActivatedRoute,
        private apiService: ApiService,
        public functionsService:FunctionsService, 
        public router: Router, 
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private breadcrumbService: BreadcrumbService){
            this.translate.setDefaultLang('en');
            this.functionsService.setTitle('account.view-receipt');
            this.activatedRoute.params.subscribe(params => {
                this.paymentId = params['paymentId'];
            });
        } 

    ngOnInit(){
        this.spinner.show();
        document.getElementById("print").hidden = true;
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        this.breadcrumbService.set('view-receipt', 'View Receipt');
        
        this.getOrganization();
        this.getPaymentInfo();
        this.getSubscription();
    }

    getPaymentInfo(){
        this.apiService.getPaymentInfoReceipt(this.paymentId).subscribe(
            data => {
                this.paymentInfo = data;
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
            }
        );
    }

    getSubscription(){
        this.apiService.getSubscription().subscribe(
            data => {
                this.subscription = data;
            },
            error => {
                this.spinner.hide();
            }
        );
    }

    getOrganization(){
        this.apiService.getOrganization().subscribe(
            data => {
                this.organization = data;
                this.organization.logo = this.organization.logo?this.organization.logo:'';
            },
            error => {
            }
        );
    }

    getPdfReceipt(){
        var prtContent = document.getElementById("print");
        var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(prtContent.innerHTML);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.document.title = `Social-Alert-${this.translate.instant('account.view-receipt')}-${this.paymentInfo.id}`;
        WinPrint.print();
        if(WinPrint.history.length==0) {
            WinPrint.ontouchcancel = function(){WinPrint.close();};
            WinPrint.onafterprint = function(){WinPrint.close();};
            }
            else {
            WinPrint.close();
        }
    }
}